"use client";
import clsx from "clsx";
import type { ReactNode } from "react";
import { type Control, type FieldValues, type Path, useController } from "react-hook-form";

type Props<T extends FieldValues> = {
  children: ReactNode;
  name: Path<T>;
  control: Control<T>;
  className?: string;
  disabled?: boolean;
};
export const Checkbox = <T extends FieldValues>({ children, name, control, className, disabled }: Props<T>) => {
  const {
    field: { value, ...field },
  } = useController({ name, control });

  return (
    <label
      className={clsx(
        "flex items-center gap-3 select-none group",
        disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer",
        className,
      )}
    >
      <div
        className={clsx("size-4 rounded-sm bg-white border grid place-items-center shrink-0", {
          "border-pr-1 text-pr-1": value,
          "border-bg-2 group-hover:border-tx-2": !value,
        })}
      >
        {value && (
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="9" viewBox="0 0 12 9" fill="none">
            <path d="M0.729492 2.72144L4.47949 6.72144L10.7295 0.721436" stroke="currentColor" strokeWidth="2" />
          </svg>
        )}
      </div>
      <p
        className={clsx("", {
          "text-tx-3": !value,
          "text-tx-1": value,
        })}
      >
        {children}
      </p>
      <input className="sr-only" type="checkbox" disabled={disabled} checked={!!value} {...field} />
    </label>
  );
};
